import { useRouter } from 'next/router';
import CmsDetail from '../cms/detail';
import { useEffect } from 'react';

const PageDetail = ({ customType: page, preview }) => {
  const router = useRouter();

  // Handle hash scrolling on mount and route change
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        // Find element with matching data-scroll-to attribute
        const scrollTarget = hash.substring(1); // Remove the #
        const element = document.querySelector(`[data-scroll-to="${scrollTarget}"]`);
        
        if (element) {
          // Use our custom scroll with offset after a delay
          setTimeout(() => {
            const offset = 100;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: elementPosition - offset,
              behavior: 'smooth',
            });
          }, 100);
        }
      }
    };

    // Handle initial load
    handleHashScroll();
    
  }, [router]);


  return (
    <CmsDetail content={page} preview={preview} leftAlign={page.leftalign} />
  );
};

export default PageDetail;
